(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-alert"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dlg = document.querySelector('[data-drop-alert]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    const key = dlg.dataset.key;
    const store = {
      get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} },
      flag: (k, v) => { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } },
    };
    const at = Date.parse(dlg.dataset.release);
    const pad = (n) => String(n).padStart(2, '0');
    const units = {}; dlg.querySelectorAll('[data-unit]').forEach((el) => { units[el.dataset.unit] = el; });
    const tick = () => {
      const left = at - Date.now(); if (Number.isNaN(at) || left <= 0) return false;
      const sec = Math.floor(left / 1000);
      units.d.textContent = pad(Math.floor(sec / 86400)); units.h.textContent = pad(Math.floor(sec / 3600) % 24);
      units.m.textContent = pad(Math.floor(sec / 60) % 60); units.s.textContent = pad(sec % 60);
      return true;
    };
    let timer = null;
    // Once seen, it does not open by itself again for a day (owner, 2026-10-22: "if they see it it doesn't show the
    // rest of the day"), whether it was closed, ignored or the visitor left: the moment it opens is what counts.
    const markSeen = () => store.set(key + '-seen', String(Date.now()));
    let pinnedAt = null;
    const lock = () => {
      if (pinnedAt !== null) return;
      pinnedAt = window.scrollY; document.body.style.top = `-${pinnedAt}px`; document.documentElement.classList.add('dalert-lock');
    };
    const unlock = () => {
      if (pinnedAt === null) return;
      const y = pinnedAt; pinnedAt = null;
      document.documentElement.classList.remove('dalert-lock'); document.body.style.top = '';
      window.scrollTo({ top: y, left: 0, behavior: 'instant' });
    };
    const open = () => { if (dlg.open) return; markSeen(); tick(); timer = setInterval(() => { if (!tick()) clearInterval(timer); }, 1000); dlg.showModal(); lock(); };
    // Every way out unlocks the page itself (the browser's own close signal can come late), and that signal too.
    const shut = () => { clearInterval(timer); if (dlg.open) dlg.close(); unlock(); };
    dlg.addEventListener('close', () => { clearInterval(timer); unlock(); });
    dlg.addEventListener('cancel', () => setTimeout(() => { if (!dlg.open) unlock(); }, 0));
    dlg.querySelector('[data-dalert-close]').addEventListener('click', () => shut());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) shut(); });
    // The picture goes to the drop product; already there, it just closes the card.
    dlg.querySelector('[data-dalert-piclink]')?.addEventListener('click', (e) => {
      if (new URL(e.currentTarget.href, location.href).pathname === location.pathname) { e.preventDefault(); shut(); }
    });
    // The page reloads after the form is sent; this marks that the sent form was this one, not the footer's.
    // Every address also goes to the shop's sign-up handler (owner, 2026-10-22: "I just want to see all the users who
    // sign up through that pop-up"): Shopify's form adds the tag to new customers only, the handler tags existing
    // ones too, so the drop's segment holds everyone (§45). A beacon, so it is sent even as the page reloads.
    dlg.querySelector('[data-dalert-form]')?.addEventListener('submit', (e) => {
      store.flag(key + '-sent', '1');
      const email = e.target.querySelector('input[type="email"]')?.value || '';
      if (dlg.dataset.endpoint && email && navigator.sendBeacon) {
        try { navigator.sendBeacon(dlg.dataset.endpoint, new URLSearchParams({ email, tag: dlg.dataset.tag })); } catch (err) {}
      }
      // Meta hears that a sign-up happened (owner, 2026-10-28), so Ads Manager can show sign-ups per ad. Only the event
      // and the drop's tag go from here; where the pixel is not on the page (blocked, or no consent) this does nothing (§47).
      if (email && typeof window.fbq === 'function') {
        try { window.fbq('track', 'Lead', { content_name: dlg.dataset.tag || 'Drop alert' }); } catch (err) {}
      }
    });

    // "Get notified" buttons (the drop product's page) open it on demand, at any time before the release; they
    // stay hidden after it, and when this pop-up is not on the page they are never shown.
    const before = !Number.isNaN(at) && Date.now() < at;
    document.querySelectorAll('[data-open-drop-alert]').forEach((b) => {
      b.hidden = !before;
      b.addEventListener('click', (e) => { e.preventDefault(); open(); });
    });

    // In the theme editor: open when the section is chosen, never on its own.
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => { if (dlg.closest('.shopify-section')?.id === 'shopify-section-' + e.detail.sectionId) open(); });
      document.addEventListener('shopify:section:deselect', () => shut());
      return;
    }
    const posted = dlg.querySelector('[data-dalert-posted]') && store.flag(key + '-sent') === '1';
    const failed = dlg.querySelector('[data-dalert-error]') && store.flag(key + '-sent') === '1';
    if (posted) { store.set(key + '-done', '1'); store.flag(key + '-sent', '0'); open(); return; }
    if (failed) { open(); return; }
    if (Number.isNaN(at) || Date.now() >= at) return;
    if (store.get(key + '-done') === '1') return;
    const seen = Number(store.get(key + '-seen') || store.get(key + '-closed') || 0);
    if (seen && Date.now() - seen < Number(dlg.dataset.quietDays || 1) * 86400000) return;
    setTimeout(open, Math.max(0, Number(dlg.dataset.delay || 3)) * 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop"] && !Shopify.designMode) return;
  try {
    
  // The sweater's pictures, one at a time: dots and arrows follow the swipe and move it.
  document.querySelectorAll('[data-drop-gallery]').forEach((g) => {
    const track = g.querySelector('[data-drop-track]'); if (!track) return;
    const slides = [...track.querySelectorAll('[data-drop-slide]')], dots = [...g.querySelectorAll('[data-drop-dot]')];
    const at = () => Math.round(track.scrollLeft / Math.max(1, slides[0]?.offsetWidth + 10));
    const mark = (i = at()) => dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
    const go = (i) => { const n = Math.max(0, Math.min(slides.length - 1, i)); mark(n); track.scrollTo({ left: slides[n].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' }); };
    track.addEventListener('scroll', () => mark(), { passive: true });
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    g.querySelector('[data-drop-prev]')?.addEventListener('click', () => go(at() - 1));
    g.querySelector('[data-drop-next]')?.addEventListener('click', () => go(at() + 1));
  });
  (() => {
    // Each digit in its own slot; days can run to three.
    const put = (el, n) => {
      const text = String(n).padStart(2, '0');
      if (el.children.length !== text.length) el.innerHTML = '<i></i>'.repeat(text.length);
      [...text].forEach((ch, i) => { if (el.children[i].textContent !== ch) el.children[i].textContent = ch; });
    };
    document.querySelectorAll('[data-drop]').forEach((root) => {
      const at = Date.parse(root.dataset.release);
      if (Number.isNaN(at)) return;
      const units = {};
      root.querySelectorAll('[data-unit]').forEach((el) => { units[el.dataset.unit] = el; });
      const tick = () => {
        const left = at - Date.now();
        if (left <= 0) { root.dataset.state = 'after'; return false; }
        const sec = Math.floor(left / 1000);
        put(units.d, Math.floor(sec / 86400));
        put(units.h, Math.floor(sec / 3600) % 24);
        put(units.m, Math.floor(sec / 60) % 60);
        put(units.s, sec % 60);
        return true;
      };
      if (tick()) { const id = setInterval(() => { if (!tick()) clearInterval(id); }, 1000); }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
